
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function Operation({operation, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    {/* <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={operation?.photo !== null ? operation?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div> */}
                    <div className="widget-content-left">
                        <div className="widget-heading">{operation?.nomuser !== null ? operation?.nomuser : ""} {operation?.prenomuser !== null ? operation?.prenomuser : ""}</div>
                        <div className="widget-subheading">{operation?.emailuser !== null ? operation?.emailuser : ""}</div>
                    </div>
                </div>
            </td>
            <td>
                <div className="d-flex flex-row">
                    {/* <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={operation?.image !== null ? operation?.image : "/assets/imgs/blank.png"} alt="" />
                    </div> */}
                    <div className="widget-content-left">
                        <div className="widget-heading">{operation?.login !== null ? operation?.login : ""}</div>
                        <div className="widget-subheading">{operation?.lib !== null ? operation?.lib : ""}</div>
                    </div>
                </div>
            </td>
            <td>{operation?.objetaction !== null ? operation?.objetaction.replace("{", "").replace("}", "") : ""}</td>
            <td>{operation?.action !== null ? operation?.action : ""}</td>
            <td><ReactTimeAgo date={Date.parse(operation?.datecrea)} timeStyle="facebook" /></td>
            <td className="text-center">
                <Link to={`/activite/${operation?.codemouchard}`} data-toggle="tooltip" title="View activity" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}